import "./bootstrap";
import Alpine from "alpinejs";

import { createApp } from "vue";
import FollowButton from "./Components/FollowButton.vue";
import FollowLink from "./Components/FollowLink.vue";
import LikeButton from "./Components/LikeButton.vue";

import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";

window.Alpine = Alpine;
Alpine.start();

import axios from "axios";
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Cropperjs
function initImageCropper() {
    const input = document.getElementById("image");
    const currentImage = document.getElementById("current_image");
    const cropperImage = document.getElementById("cropper-image");
    const modal = document.getElementById("cropperModal");
    const cropButton = document.getElementById("crop-button");
    const closeModalBtn = document.getElementById("closeModal");
    const cancelCropBtn = document.getElementById("cancelCrop");

    // NEW: Edit Crop button
    let editCropBtn = document.createElement("button");
    editCropBtn.type = "button";
    editCropBtn.textContent = "Edit Crop";
    editCropBtn.className = "mt-2 px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 hidden";
    currentImage.after(editCropBtn);

    let cropper = null;
    let originalImageURL = null; // store original image data URL

    function closeModal() {
        modal.classList.add("hidden");
        if (cropper) {
            cropper.destroy();
            cropper = null;
        }
    }

    closeModalBtn.addEventListener("click", closeModal);
    cancelCropBtn.addEventListener("click", closeModal);

    input.addEventListener("change", function () {
        if (this.files && this.files[0]) {
            const file = this.files[0];
            const reader = new FileReader();

            reader.onload = function (e) {
                cropperImage.src = e.target.result;
                modal.classList.remove("hidden");

                cropperImage.onload = function () {
                    if (cropper) cropper.destroy();

                    cropper = new Cropper(cropperImage, {
                        aspectRatio: 1,
                        viewMode: 1,
                        autoCropArea: 1,
                        responsive: true,
                    });

                    // Store original image data for editing later
                    window.originalImageDataUrl = e.target.result;
                };
            };
            reader.readAsDataURL(file);
        }
    });

    cropButton.addEventListener("click", function () {
        if (!cropper) {
            console.error("Cropper instance not found.");
            return;
        }

        const canvas = cropper.getCroppedCanvas({
            width: 500,
            height: 500,
            fillColor: "#ffffff",
            imageSmoothingEnabled: true,
            imageSmoothingQuality: "high",
        });

        canvas.toBlob(
            function (blob) {
                const formData = new FormData();
                formData.append("image", blob, "cropped_image.jpg");

                fetch("/settings/upload-image", {
                    method: "POST",
                    headers: {
                        "X-CSRF-TOKEN": document.querySelector(
                            'meta[name="csrf-token"]'
                        ).content,
                        Accept: "application/json",
                    },
                    body: formData,
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.success) {
                            const currentImage =
                                document.getElementById("current_image");
                            currentImage.src =
                                "/storage/" + data.image + "?v=" + Date.now();
                            document.getElementById(
                                "uploaded_image_path"
                            ).value = data.image;
                            closeModal();
                            showBanner("Image cropped successfully", "success");

                            // Show the edit crop button
                            document
                                .getElementById("edit-crop-button")
                                .classList.remove("hidden");
                        } else {
                            showBanner(
                                data.message || "Failed to crop image",
                                "error"
                            );
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                        showBanner(
                            "An error occurred while cropping the image",
                            "error"
                        );
                    });
            },
            "image/jpeg",
            0.95
        );
    });

    // Handle clicking "Edit Crop"
    document
        .getElementById("edit-crop-button")
        .addEventListener("click", function () {
            if (!window.originalImageDataUrl) {
                alert(
                    "No image available to edit. Please select an image first."
                );
                return;
            }

            cropperImage.src = window.originalImageDataUrl;
            modal.classList.remove("hidden");

            cropperImage.onload = function () {
                if (cropper) cropper.destroy();

                cropper = new Cropper(cropperImage, {
                    aspectRatio: 1,
                    viewMode: 1,
                    autoCropArea: 1,
                    responsive: true,
                });
            };
        });

    window.onclick = function (event) {
        if (event.target === modal) closeModal();
    };
}

document.addEventListener('DOMContentLoaded', function() {
    let cropper;
    const imageInput = document.getElementById('image');
    const currentImage = document.getElementById('current_image');
    const previewContainer = document.getElementById('preview-container');
    const aspectRatioSelect = document.getElementById('aspectRatio');
    const cropperModal = document.getElementById('cropperModal');
    const cropperImage = document.getElementById('cropper-image');
    const cropButton = document.getElementById('crop-button');
    const closeModalBtn = document.getElementById('closeModal');
    const cancelCropBtn = document.getElementById('cancelCrop');
    const editCropBtn = document.getElementById('edit-crop-button');
    
    // Store original image data
    let originalImageData = null;
    
    // Only proceed if we have the necessary elements
    if (imageInput && currentImage) {
        // Save the initial image URL
        originalImageData = currentImage.src;
        
        // Initialize aspect ratio if available
        if (aspectRatioSelect && previewContainer) {
            previewContainer.style.aspectRatio = aspectRatioSelect.value;
            
            // Update aspect ratio when changed
            aspectRatioSelect.addEventListener('change', function() {
                const ratio = this.value;
                document.getElementById('aspect_ratio').value = ratio;
                document.getElementById('preview-container').style.aspectRatio = ratio;
                
                if (cropper) {
                    cropper.setAspectRatio(parseFloat(ratio));
                }
            });            
        }
        
        // Handle file selection
        imageInput.addEventListener('change', function(e) {
            if (this.files && this.files[0]) {
                const file = this.files[0];
                const reader = new FileReader();
                
                reader.onload = function(event) {
                    originalImageData = event.target.result;
                    initializeCropper(originalImageData);
                };
                
                reader.readAsDataURL(file);
            }
        });
        
        // Handle edit crop button if it exists
        if (editCropBtn) {
            editCropBtn.addEventListener('click', function() {
                if (originalImageData) {
                    initializeCropper(originalImageData);
                } else {
                    alert("No image available to edit. Please select an image first.");
                }
            });
        }
        
        // Initialize cropper
        function initializeCropper(imageSrc) {
            if (!cropperModal || !cropperImage) return;
            
            cropperImage.src = imageSrc;
            cropperModal.classList.remove('hidden');
            
            if (cropper) {
                cropper.destroy();
            }
            
            const aspectRatio = aspectRatioSelect ? parseFloat(aspectRatioSelect.value) : 1;
            
            cropper = new Cropper(cropperImage, {
                aspectRatio: aspectRatio,
                viewMode: 1,
                autoCropArea: 1,
                responsive: true
            });
        }
        
        // Handle crop button
        if (cropButton) {
            cropButton.addEventListener('click', function() {
                if (!cropper) return;
                
                const aspectRatio = aspectRatioSelect ? parseFloat(aspectRatioSelect.value) : 1;
                
                const canvas = cropper.getCroppedCanvas({
                    width: 1080,
                    height: Math.round(1080 / aspectRatio)
                });
                
                canvas.toBlob(function(blob) {
                    const formData = new FormData();
                    formData.append('image', blob, 'cropped_image.jpg');
                    formData.append('aspect_ratio', aspectRatio);
                    
                    fetch('/upload-cropped-image', {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            currentImage.src = data.image_url;
                            document.getElementById('uploaded_image_path').value = data.image_path;
                            if (cropperModal) cropperModal.classList.add('hidden');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
                }, 'image/jpeg', 0.95);
            });
        }
        
        // Close modal handlers
        if (closeModalBtn) {
            closeModalBtn.addEventListener('click', function() {
                if (cropperModal) cropperModal.classList.add('hidden');
                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }
            });
        }
        
        if (cancelCropBtn) {
            cancelCropBtn.addEventListener('click', function() {
                if (cropperModal) cropperModal.classList.add('hidden');
                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }
            });
        }
    }
});

// Ajax
document.addEventListener("DOMContentLoaded", function () {
    const settingsLinks = document.querySelectorAll(".settings-link");
    const contentArea = document.querySelector("#settings-content");

    settingsLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const url = this.getAttribute("href");

            fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    contentArea.innerHTML = html;
                    history.pushState(null, "", url);
                })
                .catch((error) => console.error("Error:", error));
        });
    });
});

/////////////////////////////////////////////////////
// Mount components when DOM is ready
/////////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
    // Mount Follow Buttons
    document.querySelectorAll('[id^="FollowButtonApp-"]').forEach((element) => {
        createApp({
            data() {
                return {
                    followersCount: 0,
                };
            },
            methods: {
                updateFollowersCount(count) {
                    this.followersCount = count;
                },
            },
            components: {
                "follow-button": FollowButton,
            },
        }).mount(`#${element.id}`);
    });

    // Mount Like Buttons
    document.querySelectorAll('[id^="LikeButtonApp-"]').forEach((element) => {
        createApp({
            components: {
                "like-button": LikeButton,
            },
        }).mount(`#${element.id}`);
    });

    // Mount Mobile Follow Links
    document.querySelectorAll('[id^="FollowLinkApp-"]').forEach((element) => {
        createApp({
            data() {
                return {
                    followersCount: 0,
                };
            },
            methods: {
                updateFollowersCount(count) {
                    this.followersCount = count;
                },
            },
            components: {
                "follow-link": FollowLink,
            },
        }).mount(`#${element.id}`);
    });

    // Cropper
    if (document.getElementById("cropper-image")) {
        initImageCropper();
    }

    // Password Toggle
    const toggleButtons = document.querySelectorAll(".toggle-password");
    toggleButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const input = this.previousElementSibling;
            const type =
                input.getAttribute("type") === "password" ? "text" : "password";
            input.setAttribute("type", type);
            this.querySelector("svg").innerHTML =
                type === "password"
                    ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />'
                    : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />';
        });
    });

    // Password requirements
    const passwordInput = document.getElementById("password");
    const requirements = document.querySelectorAll(".requirement");

    passwordInput.addEventListener("input", function () {
        const password = this.value;

        // Check each requirement
        requirements.forEach((req) => {
            const rule = req.getAttribute("data-rule");
            let passed = false;

            switch (rule) {
                case "min":
                    passed = password.length >= 8;
                    break;
                case "mixed":
                    passed = /[a-z]/.test(password) && /[A-Z]/.test(password);
                    break;
                case "numbers":
                    passed = /\d/.test(password);
                    break;
                case "symbols":
                    passed = /[!@#$%^&*(),.?":{}|<>]/.test(password);
                    break;
            }

            req.textContent = passed ? "✅" : "❌";
        });
    });

    
});

// Header Image
document.getElementById('header_image').addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            document.getElementById('header-preview').src = e.target.result;
        }
        reader.readAsDataURL(file);
    }
});

// Posts Preview Image
document.addEventListener("change", function (event) {
    if (event.target && event.target.id === "image") {
        const file = event.target.files[0];
        const previewImage =
            document.getElementById("preview_image") ||
            document.getElementById("current_image");

        if (file && previewImage) {
            const reader = new FileReader();
            reader.onload = function (e) {
                previewImage.src = e.target.result;
            };
            reader.readAsDataURL(file);
        } else if (previewImage) {
            // If no file is selected, show placeholder again
            previewImage.src = "{{ asset('placeholder.jpg') }}";
        }
    }
});

// Comments
document.addEventListener("DOMContentLoaded", function () {
    const commentForms = document.querySelectorAll(".comment-form");

    commentForms.forEach((form) => {
        form.addEventListener("submit", async function (e) {
            e.preventDefault();

            const submitButton = this.querySelector('button[type="submit"]');
            const input = this.querySelector('input[name="content"]');
            submitButton.disabled = true;

            try {
                const formData = new FormData(this);
                const response = await fetch(this.action, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "X-CSRF-TOKEN": document.querySelector(
                            'meta[name="csrf-token"]'
                        ).content,
                        Accept: "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    // Find the comments container relative to the current form
                    const commentsContainer = document.querySelector(
                        ".post-details .space-y-4"
                    );

                    if (commentsContainer) {
                        // Add new comment to the top of the list
                        commentsContainer.insertAdjacentHTML(
                            "afterbegin",
                            data.comment
                        );

                        // Clear the input
                        input.value = "";

                        // Remove "no comments" message if it exists
                        const noComments = commentsContainer.querySelector(
                            ".text-center.text-gray-500"
                        );
                        if (noComments) {
                            noComments.remove();
                        }
                    }
                }
            } catch (error) {
                console.error("Error:", error);
            } finally {
                submitButton.disabled = false;
            }
        });
    });
});

// Post deletion
window.deletePost = async function (event, postId) {
    if (confirm("Are you sure you want to delete this post?")) {
        try {
            const response = await axios.delete(`/p/${postId}`, {
                headers: {
                    "X-CSRF-TOKEN": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            });

            if (response.status === 200) {
                const currentPath = window.location.pathname;

                if (currentPath === `/p/${postId}`) {
                    window.location.href = `/${response.data.username}`;
                } else {
                    const postElement = event.target.closest("article");
                    if (postElement) {
                        postElement.remove();

                        // Show success message using the ID-based banner
                        showBanner("Post deleted successfully");
                    }
                }
            }
        } catch (error) {
            console.error("Error deleting post:", error);
            alert("Failed to delete post. Please try again.");
        }
    }
};

// Function to show the banner success and error messages
function showBanner(message, type = 'success') {
    const banner = document.getElementById('alert-banner');
    const className = type === 'success' ? 'bg-green-100 border-green-400 text-green-700' : 'bg-red-100 border-red-400 text-red-700';
    
    banner.innerHTML = `
        <div class="${className} px-4 py-3 rounded relative shadow-md" role="alert">
            <span class="block sm:inline">${message}</span>
            <button type="button" class="absolute top-0 bottom-0 right-0 px-4 py-3" onclick="closeBanner()">
                <svg class="fill-current h-6 w-6 ${type === 'success' ? 'text-green-500' : 'text-red-500'}" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <title>Close</title>
                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/>
                </svg>
            </button>
        </div>
    `;
    
    banner.classList.remove('hidden');
    
    setTimeout(() => {
        if (!banner.classList.contains('hidden')) {
            banner.classList.add('hidden');
        }
    }, 4000);
}

function closeBanner() {
    document.getElementById('alert-banner').classList.add('hidden');
}

if (typeof successMessage !== 'undefined' && successMessage) {
    showBanner(successMessage, 'success');
} else if (typeof errorMessage !== 'undefined' && errorMessage) {
    showBanner(errorMessage, 'error');
}

// Function to close the banner
window.closeBanner = function () {
    const banner = document.getElementById("delete-post-success-banner");
    banner.classList.add("hidden");
};

// Login Banner for posts
document.addEventListener("DOMContentLoaded", function () {
    const postLinks = document.querySelectorAll(".post-link");

    postLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            const postUrl = this.href;
            const checkAuthUrl = this.dataset.checkAuthUrl;
            const postId = this.dataset.postId;

            fetch(checkAuthUrl, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    let modal;

                    if (data.authorized) {
                        window.location.href = postUrl;
                    } else {
                        if (data.requiresLogin) {
                            // Get/Create login modal
                            modal = document.getElementById("loginModal");
                            if (!modal) {
                                // Create the modal dynamically if it doesn't exist
                                modal = createLoginModal(postId, postUrl);
                                document.body.appendChild(modal); // Append to the body
                            }

                            modal.classList.remove("hidden"); // Show the login modal
                        } else if (data.requiresFollow) {
                            // Get/Create follow modal
                            modal = document.getElementById("followModal");
                            if (!modal) {
                                // Create the modal dynamically if it doesn't exist
                                modal = createFollowModal(
                                    postId,
                                    postUrl,
                                    data.profileUsername
                                );
                                document.body.appendChild(modal); // Append to the body
                            }

                            modal.classList.remove("hidden"); // Show the follow modal
                        } else {
                            alert(
                                data.message ||
                                    "You are not authorized to view this post."
                            );
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    alert("An error occurred. Please try again.");
                });
        });
    });

    //Helper Function to create the login modal
    function createLoginModal(postId, redirectUrl) {
        const modal = document.createElement("div");
        modal.id = "loginModal";
        modal.className =
            "hidden fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-50 flex items-center justify-center";

        const modalContent = document.createElement("div");
        modalContent.className = "bg-white p-8 rounded shadow-lg w-1/3";

        const closeButton = document.createElement("button");
        closeButton.className = "float-right text-gray-600 hover:text-gray-800";
        closeButton.innerHTML = "&times;";
        closeButton.addEventListener("click", () => {
            modal.classList.add("hidden");
        });

        const message = document.createElement("p");
        message.textContent = "You must login to view this post.";
        message.className = "mb-4";

        const loginLink = document.createElement("a");
        loginLink.href = `/login?redirect=/p/${postId}`; // Add postId as a query parameter to the redirect URL
        loginLink.textContent = "Login";
        loginLink.className =
            "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded";

        modalContent.appendChild(closeButton);
        modalContent.appendChild(message);
        modalContent.appendChild(loginLink);

        modal.appendChild(modalContent);

        return modal;
    }

    //Helper Function to create the follow modal
    function createFollowModal(postId, redirectUrl, profileUsername) {
        const modal = document.createElement("div");
        modal.id = "followModal";
        modal.className =
            "hidden fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-50 flex items-center justify-center";

        const modalContent = document.createElement("div");
        modalContent.className = "bg-white p-8 rounded shadow-lg w-1/3";

        const closeButton = document.createElement("button");
        closeButton.className = "float-right text-gray-600 hover:text-gray-800";
        closeButton.innerHTML = "&times;";
        closeButton.addEventListener("click", () => {
            modal.classList.add("hidden");
        });

        const message = document.createElement("p");
        message.textContent = `You must follow ${profileUsername} to view this post.`;
        message.className = "mb-4";

        const followLink = document.createElement("a");
        followLink.href = `/${profileUsername}`; // Link to the user's profile
        followLink.textContent = "View Profile and Follow";
        followLink.className =
            "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded";

        modalContent.appendChild(closeButton);
        modalContent.appendChild(message);
        modalContent.appendChild(followLink);

        modal.appendChild(modalContent);

        return modal;
    }
});
